import { render, staticRenderFns } from "./AppInstagramIcon.vue?vue&type=template&id=35d5cbc9"
import script from "./AppInstagramIcon.vue?vue&type=script&lang=js"
export * from "./AppInstagramIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports